import { where } from "firebase/firestore"
import { useQuery } from "hooks/firestore/core/useQuery"
import { getShopsRef } from "hooks/firestore/getRefs"
import { useUser } from "hooks/firestore/simple/useUser"
import { UserOnShop } from "types/firestore/shop"

export function useUserShops() {
  const user = useUser()
  const entries: UserOnShop[] = user?._ref.id
    ? (["superadmin", "admin", "member", "guest", "user"] as const).map(role => ({ role, id: user?._ref.id }))
    : []

  const { documents } = useQuery(getShopsRef(), where("users", "array-contains-any", ["dummy", ...entries]))
  return documents
}
